import { useTranslation } from 'react-i18next';

export default function BookingSection() {
  const { t } = useTranslation();

  return (
    <section id="booking" className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12 xl:px-16">
        <div className="max-w-4xl mx-auto text-center">
          <span className="text-sm font-semibold text-primary-600 tracking-wider uppercase">
            {t('nav.booking')}
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mt-3">
            {t('booking.title')}
          </h2>
          <p className="mt-3 text-foreground-600 max-w-xl mx-auto">
            {t('booking.description')}
          </p>

          <div className="mt-10 bg-background-100 rounded-lg border border-background-200 p-6 md:p-10">
            <div className="flex flex-col items-center justify-center py-12 md:py-16">
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
                <i className="ri-calendar-check-line text-3xl" />
              </div>
              <p className="text-foreground-600 text-sm">
                {t('booking.iframePlaceholder')}
              </p>
              <p className="text-foreground-400 text-xs mt-2">
                Hier wird das Buchungssystem Ihres Anbieters eingebunden.
              </p>
            </div>

            <div className="w-full h-[500px] bg-white rounded-lg border border-background-200 flex items-center justify-center overflow-hidden">
              <div className="text-center px-4">
                <i className="ri-window-line text-4xl text-foreground-300 mb-3" />
                <p className="text-foreground-500 text-sm font-medium">
                  iframe-Buchungssystem Platzhalter
                </p>
                <p className="text-foreground-400 text-xs mt-1">
                  Fügen Sie hier den iframe-Code Ihres Buchungsanbieters ein.
                </p>
                <code className="mt-3 block text-xs text-foreground-400 bg-background-50 p-2 rounded">
                  &lt;iframe src=&quot;IHR_BUCHUNGS_URL&quot;&gt;&lt;/iframe&gt;
                </code>
              </div>
            </div>
          </div>

          <a
            href="https://www.fewo-direkt.de/ferienwohnung-ferienhaus/p5444575"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-flex items-center gap-2 px-6 py-3 bg-secondary-500 hover:bg-secondary-600 text-white text-sm font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-external-link-line" />
            {t('booking.externalCta')}
          </a>
        </div>
      </div>
    </section>
  );
}